import { render, staticRenderFns } from "./storage-item.vue?vue&type=template&id=9cb1afde&scoped=true&"
import script from "./storage-item.vue?vue&type=script&lang=js&"
export * from "./storage-item.vue?vue&type=script&lang=js&"
import style0 from "./storage-item.vue?vue&type=style&index=0&id=9cb1afde&lang=scss&scoped=true&"
import style1 from "./storage-item.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb1afde",
  null
  
)

export default component.exports